import {
  authReq
} from '@/utils/http'

// Device related
//
// getDevices api
// @param Number page 页数
// @param Number pageSize 页面大小（每页内容条数）
// @param String sort 排序规则（多个条件使用 ',' 分割）
// @param Object filters 过滤条件
const getDevices = (page, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/dev', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const updateDevice = (sn, type, protocol, connEncry, firstAlive, gameNotify) => {
  return authReq.put(`/api/v1/dev/${sn}`, {
    type,
    protocol,
    'conn_encry': connEncry,
    'first_alive': firstAlive,
    'game_notify': gameNotify
  })
}

// unbind api
// @param Number sn 设备号
const unbind = (sn) => {
  return authReq.post('/api/v1/dev/unbind', {
    sn
  })
}

// batchUnbind api
// @param sns 需要解绑的设备号列表
const batchUnbind = (sns) => {
  return authReq.post('/api/v1/dev/batch_unbind', { sns })
}

const batchMigrate = (sns, userid, title, type) => {
  return authReq.post('/api/v1/dev/batch_migrate', {
    'userid': userid,
    'type': type,
    title,
    sns
  })
}

// bindUrl api
// @param clientid 设备 IMEI 号
// @param iccid 物联卡号
const bindUrl = (clientid, iccid) => {
  return authReq.post('/api/v1/dev/bind_url', {
    clientid, iccid
  })
}

// batchAdd api
// @param userid 用户 ID
// @param clientids 设备 IMEI 号列表
// @param type 设备类型
// @param title 设备名
// @param platform 平台
const batchAdd = (userid, clientids, type, title, platform, protocol, connEncry, factoryId) => {
  return authReq.post('/api/v1/dev/batch_add', {
    userid, clientids, type, title, platform, protocol, 'conn_encry': connEncry, 'factory_id': factoryId
  })
}

// remoteUpgrade api
// @param sn 设备号
// @param dev 需要升级的设备
// @param init 是否需要初始化 0 不需要 1 需要
// @param type 升级类型 http, tcp
const remoteUpgrade = (sn, dev, init, type) => {
  return authReq.post('/api/v1/dev/remote_upgrade', {
    sn, dev, init, type
  })
}

export default {
  getDevices,
  updateDevice,
  unbind,
  batchUnbind,
  batchMigrate,
  bindUrl,
  batchAdd,
  remoteUpgrade
}



// WEBPACK FOOTER //
// ./src/api/deviceApi.js